import { render, staticRenderFns } from "./BuyerReceivingDetail.vue?vue&type=template&id=5d48417e&"
import script from "./BuyerReceivingDetail.vue?vue&type=script&lang=js&"
export * from "./BuyerReceivingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyerReceivingDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports